<template>
  <div class="import-upload-tips ant-modal-content" :class="{ show: importTipsVisible }">
    <div class="ant-modal-close">
      <span class="ant-modal-close-x" @click="onClose()">
        <a-icon type="close" />
      </span>
    </div>
    <div class="ant-modal-header">
      <div class="ant-modal-title">文件处理<a-button type="link" @click="onGoto()">我的导入导出</a-button></div>
    </div>
    <div class="ant-modal-body">
      <div v-for="(item, index) in userFileTask" :key="index" class="list-item">
        <div class="file-name">
          <span v-if="item.taskType===1">
            <sass-icon type="hi-daochu" />
            {{ item.fileName }}
          </span>
          <span v-else>
            <sass-icon type="hi-daoru" />
            {{ item.userFileName }}
          </span>
        </div>
        <div class="task-result" :class="{error: item.taskStatus<=0}">
          <a-icon v-if="item.taskStatus===3" type="check-circle"/>
          <a-icon v-else-if="item.taskStatus===2|| item.taskStatus===1" type="clock-circle"/>
          <a-icon v-else type="close-circle" />
          {{ item.taskResult }}
        </div>
        <div class="task-btns">
          <a-button v-if="item.taskStatus<=0&&item.fileUrl" type="link" @click="downloadErrorFile(item)">下载错误详情</a-button>
          <a-button v-else-if="item.taskType===1&&item.fileUrl" type="link" @click="downloadFile(item.fileUrl, item.fileName)">下载导出文件</a-button>
          <a-button v-else-if="item.fileUrl" type="link" @click="downloadFile(item.userFileUrl, item.userFileName)">下载导入模板</a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    userFileTask() {
      return this.$store.state.user.userFileTask
    },
    importTipsVisible() {
      return this.$store.state.user.importTipsVisible
    }
  },
  watch: {},
  methods: {
    async downloadErrorFile({ fileUrl, fileType, fileName }) {
      fileName = fileName.replace(/\.[^/.]+$/, '')
      await this.downloadFile(fileUrl, `${fileName}${fileType || '.txt'}`)
    },
    async downloadFile(url, filename) {
      try {
        // 发起请求
        const response = await fetch(url)
        if (!response.ok) {
          this.$message.error('文件下载失败')
          throw new Error('文件下载失败')
        }
        // 将响应转换为 Blob
        const blob = await response.blob()
        // 创建 Blob URL
        const blobUrl = window.URL.createObjectURL(blob)
        // 创建 <a> 标签并触发下载
        const link = document.createElement('a')
        link.href = blobUrl
        if (filename) link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // 释放 Blob URL
        window.URL.revokeObjectURL(blobUrl)
        this.$message.success('文件下载成功')
      } catch (error) {
        this.$message.error(error)
      }
    },
    onClose() {
      this.$store.commit('setimportTipsVisible', false)
    },
    onGoto() {
      this.$store.commit('setImportDowloadVisible', true)
    }
  }
}
</script>
<style lang="less">
.import-upload-tips {
  width: 500px;
  min-height: 200px;
  position: fixed!important;
  bottom: 20px;
  right: -520px;
  transition: right 0.5s ease-in-out;

  .ant-modal-body {
    padding: 20px;
  }

  &.show {
    right: 20px;
  }

  .list-item {
    line-height: 40px;
    display: flex;
    gap: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: solid 1px #f5f5f5;

    .task-btns {
      width: 100px;
      text-align: center;
    }

    .task-result {
      width: 100px;
      text-align: left;
      .anticon {
        margin-right: 5px;
        font-size: 16px;
      }
      &.error {
        color: #FB5146;
      }
      .anticon-check-circle {
        color: #1cb09f;
      }
      .anticon-clock-circle {
        color: #007AFE;
      }
      .anticon-close-circle {
        color: #FB5146;
      }
    }

    .file-name {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .anticon {
        color: #1cb09f;
        margin-right: 5px;
        font-size: 16px;
      }
    }
  }
}
</style>
